import React from 'react';
import { CurrencyInput, Form } from '@common/components';
const rules = [{ required: true, message: 'Please enter a billing amount' }];
const style = { width: '110px' };

export const DisputeBillingAmountInput = () => (
  <>
    <Form.Item name="billingAmount" rules={rules} style={style}>
      <CurrencyInput
        className="dispute-billing-amount-input"
        placeholder="Billing Amount"
      />
    </Form.Item>
    <style jsx>
      {`
        :global(.dispute-billing-amount-input .ant-input-number-handler-wrap) {
          display: none;
        }
      `}
    </style>
  </>
);
